/**
 * Group an array of identical objects by a given key.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/groupBy
 * This feature is available in later browser versions but might still break on older browsers.
 */
export const groupByKey = (data, key, keyFormatter) => {
    return data.reduce((prev, curr) => {
        const _new = { ...prev };
        // @ts-ignore
        let value = curr[key];
        value = keyFormatter ? keyFormatter(value) : value;
        if (!_new[value]) {
            _new[value] = [];
        }
        _new[value].push(curr);
        return _new;
    }, {});
};
export const isObject = (value) => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
export const values = (value) => Object.values(value);
export const deepMerge = (target, source) => {
    const output = { ...target };
    for (const key of Object.keys(source)) {
        const sourceValue = source[key];
        const targetValue = output[key];
        if (isObject(targetValue) && isObject(sourceValue)) {
            output[key] = deepMerge(targetValue, sourceValue);
        }
        else if (sourceValue !== undefined) {
            output[key] = sourceValue;
        }
    }
    return output;
};
